import type { QueryTransactionHistoryListModel } from '@/api/transaction-history/model/transactionHistory'
import type { Mutation } from 'vuex'
import type { State, ListSortInfo, ListPageInfo, ProductInfo } from '.'

import store, { actionTypes, ListTypeEnum, ListStatusEnum } from '.'

const mutations: { [actionType: string]: Mutation<State> } = {
  [actionTypes.RESET_STATE](state): void {
    Object.assign(state, store.state())
  },

  [actionTypes.SET_PRODUCT_INFO](state, info: ProductInfo): void {
    state.productInfo = { ...state.productInfo, ...info }
  },

  [actionTypes.QUERY_TRANSACTION_LIST](
    state,
    result: QueryTransactionHistoryListModel
  ): void {
    state.transactionHistoryList = { ...result }
  },

  [actionTypes.SET_LIST_SORT_INFO](state, info: ListSortInfo): void {
    state.listSortInfo = { ...state.listSortInfo, ...info }
  },

  [actionTypes.SET_CURRENT_SORT_COLUMN_ID](state, id: string): void {
    state.currentSortColumnID = id
  },

  [actionTypes.SET_LIST_PAGE_INFO](state, info: ListPageInfo): void {
    state.listPageInfo = { ...state.listPageInfo, ...info }
  },

  [actionTypes.SET_ACTIVE_LIST_TYPE](state, type: ListTypeEnum): void {
    state.activeListType = type
  },

  [actionTypes.SET_ACTIVE_LIST_STATUS](state, status: ListStatusEnum): void {
    state.activeListStatus = status
  },

  [actionTypes.SET_REQUEST_LOCK_STATUS](state, status: boolean): void {
    state.requestLock = status
  },
}

export default mutations
